import 'intersection-observer';
import Vue from 'vue';
import App from './App.vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import '@common/assets/styles/reset.css';
import '@q-front-npm/h5-ui/lib/index.css';
import QToast from '@common/components/q-toast/index.ts';
import { polyfillRequestIdleCallback } from '@common/assets/ts/utils';
import debounceClick from '@common/directives/debounce-click';
import { initSentry } from '@common/assets/ts/sentry';

polyfillRequestIdleCallback();
Vue.use(QToast);
Vue.directive('debounce-click', debounceClick);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
const app = new Vue({
    pinia,
    render: (h) => h(App),
});
initSentry();

if (import.meta.env.VITE_ENV !== 'production') {
    import('vconsole').then((res) => {
        new res.default(); // 初始化VConsole实例
        app.$mount('#app');
    });
} else {
    app.$mount('#app');
}
